import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';
import { Observable } from 'rxjs';
import { ResponseBase } from '../models/response-base';
import { FilterCard, FilterCreditHistory, FilterExpenses, FilterUseProducts } from '../models/relatorio';

@Injectable({
    providedIn: 'root'
})
export class RelatorioService {

    URL: string = environment.GATEWAY + 'report';

    constructor(private http: HttpClient) { }

    getDetailedUseProducts(cedenteGuid: string, page: number, limit: number, filtro: FilterUseProducts): Observable<ResponseBase<any>> {
        return this.http.post<ResponseBase<any>>(`${this.URL}/${cedenteGuid}/page/${page}/limit/${limit}`, filtro);
    }

    getSummarizedUseProducts(cedenteGuid: string, page: number, limit: number, filtro: FilterUseProducts): Observable<ResponseBase<any>> {
        return this.http.post<ResponseBase<any>>(`${this.URL}/collaborator/products/summarized/${cedenteGuid}/page/${page}/limit/${limit}`, filtro);
    }
    
    getDetailedBalance(cedenteGuid: string, page: number, limit: number, filtro: FilterUseProducts): Observable<ResponseBase<any>> {
        return this.http.post<ResponseBase<any>>(`${this.URL}/collaborator/balance/detailed/${cedenteGuid}/page/${page}/limit/${limit}`, filtro);
    }
    
    GetSummarizedBalance(cedenteGuid: string, filtro: FilterUseProducts): Observable<ResponseBase<any>> {
        return this.http.post<ResponseBase<any>>(`${this.URL}/collaborator/balance/summarized/${cedenteGuid}`, filtro);
    }
    
    GetAssignorExtract(cedenteGuid: string, page: number, limit: number, filtro: FilterUseProducts): Observable<ResponseBase<any>> {
        return this.http.post<ResponseBase<any>>(`${this.URL}/assignor/extract/${cedenteGuid}/page/${page}/limit/${limit}`, filtro);
    }
    
    getCreditHistory(cedenteGuid: string, page: number, limit: number, filtro: FilterCreditHistory): Observable<ResponseBase<any>> {
        return this.http.post<ResponseBase<any>>(`${this.URL}/credit/history/${cedenteGuid}/page/${page}/limit/${limit}`, filtro);
    }

    getPurchases(cedenteGuid: string, page: number, limit: number, filtro: FilterCreditHistory): Observable<ResponseBase<any>> {
        return this.http.post<ResponseBase<any>>(`${this.URL}/purchases/${cedenteGuid}/page/${page}/limit/${limit}`, filtro);
    }

    getCollaboratorStatus(cedenteGuid: string, page: number, limit: number, filtro: FilterUseProducts): Observable<ResponseBase<any>> {
        return this.http.post<ResponseBase<any>>(`${this.URL}/collaborator/status/${cedenteGuid}/page/${page}/limit/${limit}`, filtro);
    }

    getCardStatus(cedenteGuid: string, page: number, limit: number, filtro: FilterCard): Observable<ResponseBase<any>> {
        return this.http.post<ResponseBase<any>>(`${this.URL}/card/status/${cedenteGuid}/page/${page}/limit/${limit}`, filtro);
    }

    getCardSolicitation(cedenteGuid: string, page: number, limit: number, filtro: any): Observable<ResponseBase<any>> {
        return this.http.post<ResponseBase<any>>(`${this.URL}/card/solicitations/${cedenteGuid}/page/${page}/limit/${limit}`, filtro);
    }

    getCnhExpiration(cedenteGuid: string, page: number, limit: number): Observable<ResponseBase<any>> {
        return this.http.get<ResponseBase<any>>(`${this.URL}/cnh/expiration/${cedenteGuid}/page/${page}/limit/${limit}`);
    }

    getConsumption(cedenteGuid: string, page: number, limit: number): Observable<ResponseBase<any>> {
        return this.http.get<ResponseBase<any>>(`${this.URL}/consumption/${cedenteGuid}/page/${page}/limit/${limit}`);
    }

    getAllocatedBalanceTransactions(cedenteGuid: string, page: number, limit: number, filtro: FilterExpenses): Observable<ResponseBase<any>> {
        return this.http.post<ResponseBase<any>>(`${this.URL}/expenses/${cedenteGuid}/page/${page}/limit/${limit}`, filtro);
    }

    getGetExpensesBalance(cedenteGuid: string, page: number, limit: number): Observable<ResponseBase<any>> {
        return this.http.get<ResponseBase<any>>(`${this.URL}/expenses/${cedenteGuid}/page/${page}/limit/${limit}/balance`);
    }
}